import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { PopupStates } from '../Enums';
import settings from '../../../../settings';
import { CloseActivePopup } from '../../../actions/popupActions';
import store from '../../../store';

// Popup imports
class Save extends React.Component {
    getStateContent(state) {
        switch (state) {
            case PopupStates.SUCCESS: {
                return this.renderSuccess();
            }
            case PopupStates.ERROR: {
                return this.renderError();
            }
            default: {
                return (
                    <div>
                        <h1>Er gaat iets fout!</h1>
                        <p>De status ({state}) van deze popup is niet ondersteund!</p>
                    </div>
                );
            }
        }
    }

    CloseButton = () => {
        return (
            <button onClick={this.handleClose} type="button">
                OK
            </button>
        );
    };

    handleClose = () => {
        store.dispatch(CloseActivePopup());
    };

    renderSuccess = () => {
        return (
            <>
                <img src={`${settings.assetsPath}img/icons/disc_smile.png`} alt="Opslaan gelukt smiley" />
                <h1>Gelukt</h1>
                <p>Je game is opgeslagen.</p>
                <this.CloseButton />
            </>
        );
    };

    renderError = () => {
        const { popup } = this.props;
        const { response } = popup.properties;

        return (
            <>
                <h1>Opslaan niet gelukt</h1>
                <p>Probeer het later opnieuw.</p>
                <this.CloseButton />
                <span className="error-details">{response}</span>
            </>
        );
    };

    render = () => {
        const { popup } = this.props;
        const { state } = popup;

        const content = this.getStateContent(state);

        return content;
    };
}

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(mapStateToProps)(Save);
